import { Anchor, Box, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router';
import BrandContextForm from '../components/BrandContextForm';

// The Setup Guide's Brand Identity step: the same page in onboarding mode. It reads the website
// when nothing has been read yet, and either way out ("This is our brand", "Skip for now") goes
// back to the guide so the next step is in view.
const BrandContextConfirmPage = () => {
  const navigate = useNavigate();
  const { domain } = useSelector((state) => state.domain);
  const guideUrl = `/accounts/${domain.accountId}/domains/${domain.id}/guide`;
  const done = () => navigate(guideUrl);

  return (
    <Box py="md">
      <Anchor component={Link} to={guideUrl} size="sm" mb="sm" display="inline-flex" style={{ gap: 4 }}>
        <IconArrowLeft size={14} />
        <Text span size="sm">
          Setup Guide
        </Text>
      </Anchor>
      <BrandContextForm onSave={done} onSkip={done} scope="confirm" />
    </Box>
  );
};

export default BrandContextConfirmPage;
